import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(path: string) => void} deps.navigate
 * @param {(key: string) => string} deps.t
 */
export function usePostDataset({ callApiWithWorker, navigate, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createOffering"],
    mutationFn: async (payload) => {
      return callApiWithWorker(`/datasets`, {
        method: "POST",
        body: payload,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["datasets"] });
      queryClient.invalidateQueries({ queryKey: ["dataOfferings"] });

      showSuccessToast(t("createdSubMessage", "Creation successfully"), {
        title: t("createdMessage"),
      });
      navigate(-1);
    },
    onError: (error) => {
      console.error("Error al crear el dataset offering:", error);
      showErrorAlert(error);
    },
  });
}
